module.exports = __webpack_public_path__ + "static/img/6en.d9dfdef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/rongyao/6en.png
// module id = 007Q
// module chunks = 0